// extracted by mini-css-extract-plugin
module.exports = {"root":"itemList_root__0mX_x","item":"itemList_item__ZnNaa","img":"itemList_img__U0ij2","noItems":"itemList_noItems__d2vmB"};